/**
 * This file is auto-generated by the API client generator.
 * https://github.com/flowup/api-client-generator
 *
 * Avoid editing this file manually unless necessary.
 * Please report any bugs so they can be addressed in future versions.
 */

/* tslint:disable */
/* eslint-disable */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { APIClient, USE_DOMAIN, USE_HTTP_OPTIONS } from './api-client.service';
import { APIClientModuleConfig } from './types';

export { APIClient } from './api-client.service';
export { APIClientInterface } from './api-client.interface';

@NgModule({})
export class APIClientModule {
  /**
   * Use this method in your root module to provide the APIClientModule
   *
   * If you are not providing
   * @param { APIClientModuleConfig } config
   * @returns { ModuleWithProviders }
   */
  static forRoot(config: APIClientModuleConfig = {}): ModuleWithProviders<APIClientModule> {
    return {
      ngModule: APIClientModule,
      providers: [
        ...(config.domain != null ? [{provide: USE_DOMAIN, useValue: config.domain}] : []),
        ...(config.httpOptions ? [{provide: USE_HTTP_OPTIONS, useValue: config.httpOptions}] : []),
        APIClient,
      ]
    };
  }
}
